export default "__VITE_ASSET__bd66019d__"